import api from 'api';
import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

interface Props {
  attributeId: number;
  updateData: () => Promise<void>;
}

const UserAttributesDelete = ({ attributeId, updateData }: Props) => {
  const { messages } = useReduxState();

  const handleDelete = async () => {
    await api.delete(`/admin/user-custom-attributes/${attributeId}`);
    await updateData();
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.commonDelete}
      category="danger"
      confirmText={messages.attributesDeleteConfirm}
      confirmTitle={messages.attributesDelete}
      onConfirm={handleDelete}
      successMessage={messages.attributesDeleteSuccess}
      stopPropagation={true}
    />
  );
};

export default UserAttributesDelete;
